import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import moment from 'moment';
import ScheduleSectionTitle from '../ScheduleSectionTitle';
import ScheduleSectionToggle from '../ScheduleSectionToggle';
import WeeklyCalendar from './WeeklyCalendar';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  subtitle: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.primary.main,
    margin: theme.spacing(2, 0),
    ...theme.typography.h4,
  },
});

const ScheduleWeeklyView = ({
  className,
  classes,
  date,
  handleDecrementDate,
  handleIncrementDate,
  handleResetDate,
  handleToggleDailyView,
  meetingCollection,
  weeklyMeetingCollectionLoading,
}) => {
  return (
    <div className={classNames(classes.root, className)}>
      <ScheduleSectionTitle
        onDecrementDate={handleDecrementDate}
        onIncrementDate={handleIncrementDate}
        onResetDate={handleResetDate}
        buttonText="This Week"
        formattedDate={`Week of ${moment(date).startOf('week').add(1, 'day').format('MMM. Do')}`}
      />
      <div className={classes.subtitle}>
        {"Here's"} what your
        <ScheduleSectionToggle
          onClick={handleToggleDailyView}
          options={['day', 'week']}
          selected="week"
        />
        looks like:
      </div>
      <WeeklyCalendar
        date={date.toDate()}
        meetingCollection={meetingCollection}
        weeklyMeetingCollectionLoading={weeklyMeetingCollectionLoading}
      />
    </div>
  );
};

ScheduleWeeklyView.defaultProps = {
  className: '',
  weeklyMeetingCollectionLoading: false,
};

ScheduleWeeklyView.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  date: PropTypes.object.isRequired,
  handleDecrementDate: PropTypes.func.isRequired,
  handleIncrementDate: PropTypes.func.isRequired,
  handleResetDate: PropTypes.func.isRequired,
  handleToggleDailyView: PropTypes.func.isRequired,
  meetingCollection: PropTypes.array.isRequired,
  weeklyMeetingCollectionLoading: PropTypes.bool,
};

export default withStyles(styles)(ScheduleWeeklyView);
